import PhoneController from './PhoneController.vue';

export default PhoneController;
